
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.103.676A.412.412 0 010 .396C0 .29.034.193.103.116a.328.328 0 01.5 0L5 5.043 9.397.116a.328.328 0 01.5 0 .431.431 0 010 .56L5.25 5.884a.328.328 0 01-.5 0L.103.676z","fill":"#908F8D"}})])
          )
        }
      }
    